import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useContext } from "react"
import { LanguageContext } from "../../../contexts/Language"
import tw from "twin.macro"
import ArticleCard from "../../molecules/ArticleCard/ArticleCard"
import { PopularTipsProps } from "./CarCareTips.d"
import { addRoutesToArticles } from "./helpers"
import { ContactContext } from "../../../contexts/Contact"
import { parseDisclaimerBlocks } from "../../../helpers"
import { toggleDisclaimersModal } from "../../../contexts/Disclaimers/actions"

const PopularTips: React.FC<PopularTipsProps> = ({
  heading,
  category,
  translations,
  articleRoutes,
}) => {
  const { language } = useContext(LanguageContext)
  const [_state, dispatch] = useContext(ContactContext)
  const popularTips = useStaticQuery(graphql`
    query {
      popularTips: allSanityCarCareTipsPopularTips {
        nodes {
          language
          articles {
            ...ArticleData
          }
        }
      }
    }
  `)?.popularTips?.nodes?.filter((node: any) => node.language === language)[0]
    .articles

  const articlesWithRoutes = addRoutesToArticles(
    popularTips,
    articleRoutes,
    category,
    translations,
    language,
  )
  return (
    <section
      aria-label="Popular Tips Section"
      css={[
        tw`h-auto mx-auto relative px-6 mt-10 mb-10 w-full py-1 border-t border-gray-400`,
        tw`lg:(max-w-[1440px] px-10 mt-20)`,
      ]}
    >
      {articlesWithRoutes && (
        <div
          css={[
            tw`grid grid-cols-1 h-auto mx-auto relative px-6 mt-10 w-full py-1 gap-y-10 flex-col`,
            tw`lg:(grid-cols-3 auto-rows-min gap-x-10 max-w-[1440px] px-10 flex-row)`,
          ]}
        >
          <h2
            css={[
              tw`col-span-1 text-center text-2xl font-light  tracking-widest md:(text-3xl) lg:(col-span-3)`,
            ]}
          >
            {parseDisclaimerBlocks(heading, selection =>
              dispatch(toggleDisclaimersModal(selection)),
            )}
          </h2>
          {articlesWithRoutes?.map((article: any, index: number) => {
            if (article._id == null) return
            return <ArticleCard key={index} article={article} />
          })}
        </div>
      )}
    </section>
  )
}

export default PopularTips
